import { render } from "./PointsConsumption.vue?vue&type=template&id=4314855b&scoped=true"
import script from "./PointsConsumption.vue?vue&type=script&lang=js"
export * from "./PointsConsumption.vue?vue&type=script&lang=js"

import "./PointsConsumption.vue?vue&type=style&index=0&id=4314855b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4314855b"]])

export default __exports__